import Webpass from "@laragear/webpass";

async function initWithSplash() {
  if (!Webpass || (Webpass.isUnsupported && Webpass.isUnsupported())) {
    return location.replace("/login");
  }

  try {
    // `data` é o corpo (JSON) da resposta de POST /webauthn/login —
    // { success, redirect }, com o destino já resolvido pelo backend
    // (PortalRedirectResolver::afterAuthentication(), mesma lógica do login
    // nativo/Keycloak) em vez de sempre "/dashboard" fixo — um colaborador
    // só de Manutenção (sem "Visão de rede") precisa cair direto na tela de
    // chamados do hotel dele, não no dashboard geral.
    const { success, data } = await Webpass.assert(
      "/webauthn/login/options",
      "/webauthn/login"
    );

    location.replace(success ? data?.redirect || "/dashboard" : "/login");
  } catch (e) {
    console.warn("WebAuthn falhou:", e);
    location.replace("/login");
  }
}

// Expor para o `window` pra poder chamar no Blade
window.startPasskeyLogin = initWithSplash;
